import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Img } from '../../ui-kit/Img/Img.js';
import { getRegularButtonClasses } from '../../ui-kit/LinkButton/getRegularButtonClasses.js';
import { LinkButton } from '../../ui-kit/LinkButton/LinkButton.js';
import { style } from '../../utils/style.js';
export function renderBackwardButton({ version, handleClick, text = 'Вернуться назад', alwaysVisible = false, }) {
    if (!text) {
        return null;
    }
    const iconVersion = version === 'primary' ? 'white' : 'black';
    const className = 'w-12 h-12 min-h-12 min-w-12 flex items-center justify-center';
    const bgBackwardButton = version === 'primary' ? 'bg-primary-main' : 'bg-white';
    const visible = alwaysVisible ? 'flex' : 'hidden sm:flex';
    return (_jsxs("div", { className: style(visible, 'items-center gap-s'), children: [_jsx("div", { className: style(getRegularButtonClasses({ className, rounded: true }), bgBackwardButton), onClick: handleClick, children: _jsx(Img, { className: "w-4 h-4", image: {
                        icon: 'ArrowLeftIcon',
                        iconVersion: iconVersion,
                    } }) }), _jsx(LinkButton, { version: "link", className: "group-data-secondary:text-white", text: text, ariaLabel: text, onClick: handleClick, type: "button" })] }));
}
//# sourceMappingURL=renderBackwardButton.js.map